/**
 * Allocation month for a task: counts toward the due month's 160h plan when the
 * due date falls in a future month; otherwise toward the current (local) month.
 */
import { localMonthKey, monthKeyFromDateColumn } from './dates.js';

export type AllocationDueInput = Date | string | null | undefined;

function dueMonthKey(dueDate: Date | string): string {
  if (typeof dueDate === 'string') {
    return dueDate.slice(0, 7);
  }
  return monthKeyFromDateColumn(dueDate);
}

/**
 * @param dueDate  UTC-midnight DATE (server) or `YYYY-MM-DD` string (forms).
 * @param now      defaults to `new Date()`; uses local year/month as "current".
 */
export function allocationMonthKey(dueDate: AllocationDueInput, now = new Date()): string {
  const current = localMonthKey(now);
  if (!dueDate) return current;
  const dueMonth = dueMonthKey(dueDate);
  return dueMonth > current ? dueMonth : current;
}
